import React from "react";
import {
  EUROPA_LEGAL_GAZETTE_LABEL,
  EUROPA_LEGAL_GAZETTE_URL,
} from "../../data/europaLegalDisclaimer";

/**
 * Legal Footer — testo discreto sotto i loghi istituzionali Europa.
 */
export default function EuropaLegalFooter({ className = "", align = "left" }) {
  const alignClass =
    align === "center"
      ? "text-center"
      : align === "right"
        ? "text-right"
        : "text-left";

  return (
    <p
      className={`europa-legal-footer font-sans text-[11px] text-slate-500 leading-snug max-w-xl ${alignClass} ${className}`}
      data-testid="europa-legal-footer"
    >
      Sezione Europa – Rete dei Comuni Partner. Uso libero ai sensi della{" "}
      <a
        href={EUROPA_LEGAL_GAZETTE_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="europa-legal-footer__link text-slate-500 hover:text-slate-700 underline underline-offset-2 decoration-slate-400/80"
        data-testid="europa-legal-gazette-link"
      >
        {EUROPA_LEGAL_GAZETTE_LABEL}
      </a>
      . L&apos;utilizzo non implica legami formali, sponsorizzazioni o finanziamenti.
    </p>
  );
}
